var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-bar",class:{
    'disabled': _vm.disabled
  }},_vm._l((_vm.options),function(option){return _c('button',{key:option[_vm.keyValue],staticClass:"switch-option-button",class:{
      'active': (option[_vm.keyValue] === _vm.value),
      'first': (option[_vm.keyValue] === _vm.firstKey),
      'last': (option[_vm.keyValue] === _vm.lastKey)
    },domProps:{"textContent":_vm._s(option[_vm.displayValue])},on:{"click":function($event){return _vm.selected(option)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5980ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/input-templates/switch/SwitchInput.vue
// module id = null
// module chunks = 